exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select2-selection.form-control-sm {\n  padding-top: 0;\n  padding-bottom: 0;\n}\nselect.form-control:disabled + .select2 .select2-selection {\n  background-color: #ccc;\n}\nselect.form-control:disabled + .select2 .select2-selection__arrow > b {\n  display: none;\n}", ""]);

// exports
